import React, { useEffect, useState } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './ProgressWithCategories.css';

const ProgressWithCategories = ({ UserUploadedDocs }) => {
    const [progress, setProgress] = useState(0);
    const [categories, setCategories] = useState([
        { label: 'Land Use Certificate', completed: false },
        { label: 'Market Value Declaration', completed: false },
        { label: 'Digital Transfer process/Bank payment details', completed: false },
        { label: 'Bank Loan', completed: false },
    ]);
    useEffect(() => {
        const fetchData = () => {
            try {
                const updatedCategories = categories.map((category) => {
                    let completed = false;

                    UserUploadedDocs?.forEach((doc) => {
                        const type = doc.Type?.trim();
                        const value = doc.url || doc.value;

                        if (
                            category.label === 'Land Use Certificate' &&
                            type === '⁠link documents explaining the title deeds?' &&
                            value !== 'No'
                        ) {
                            completed = true;
                        }

                        if (
                            category.label === 'Market Value Declaration' &&
                            type === 'Have you obtained the Market Value Declaration Certificate?' &&
                            value !== 'No'
                        ) {
                            completed = true;
                        }

                        if (
                            category.label === 'Digital Transfer process/Bank payment details' &&
                            type === 'Have you completed the Digital Transfer process/Bank payment details?' &&
                            value !== 'No'
                        ) {
                            completed = true;
                        }

                        if (
                            category.label === 'Bank Loan' &&
                            type === 'Are you interested in applying for a bank loan?' &&
                            value !== 'No'
                        ) {
                            completed = true;
                        }
                    });

                    return { ...category, completed };
                });

                setCategories(updatedCategories);

                const completedCount = updatedCategories.filter((cat) => cat.completed).length;
                const progressValue = (completedCount / updatedCategories.length) * 100;
                setProgress(progressValue);

            } catch (error) {
                console.error('Error processing documents:', error);
            }
        };
        fetchData();
    }, [UserUploadedDocs]);
    return (
        <>
            <div className="circularProgressbar">
                <div className="progress-circle-wrapper">
                    <CircularProgressbar
                        value={progress}
                        text={`${Math.round(progress)}%`}
                        styles={buildStyles({
                            textSize: '16px',
                            pathColor: `rgb(175, 217, 224, ${progress / 100})`,
                            textColor: '#0D1B2A',
                            trailColor: '#EEF4F1',
                        })}
                    />
                </div>
                <div className="progress-categories-list">
                    {categories.map((category, index) => (
                        <div className='parentdivs' key={index}>
                            <div className='lablenew'
                                style={{
                                    width: 20,
                                    height: 20,
                                    borderRadius: '50%',
                                    backgroundColor: category.completed ? 'rgb(31, 182, 166)' : '#ccc',
                                    color: category.completed ? 'white' : 'black',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                {category.completed && (
                                    <svg width="14" height="12" viewBox="0 0 24 24">
                                        <path fill="#fff" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                                    </svg>
                                )}
                            </div>
                            <span className='lblss'>{category.label}</span>
                        </div>
                    ))}
                </div>
            </div>
            {/* 
            <h5 className="headingText">Why Consider a Bank Loan for Your Property Purchase?</h5>
            <p className="headingTextPtag">
                Purchasing property is a significant financial commitment, and securing a bank loan can make it more manageable. 
                A loan offers flexibility by spreading the cost over time, helping you acquire your dream property without the need for full upfront payment.
            </p> */}
        </>
    );
};

export default ProgressWithCategories;

